import React from "react";
import { Model } from "@flowable/forms";
import Button from "@cayuse/shared-react.components.button";
import Icon from "@cayuse/shared-react.components.icon";
import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";
import orgFinderConfig from "./orgFinderConfig";
import styles from "./SFIComponent.css";

const definition = {
	extraSettings: {
		showBorder: false,
		collapsible: false,
		collapsed: false,
		multipleEntries: true,
		showAddButton: true,
		showDeleteButton: true,
		minItems: 1,
	},
};

class SFIComponent extends Model.StatefulFormComponent {
	render () {
		const { Components } = this.props;
		const Subform = Components.subform;

		return (
			<div className={`${styles.sfiComponent} sfiComponent`}>
				<hr className={styles.dividingLine}/>
				<div>
					<Button primary className={styles.acceptButton}><Icon name="check" />Review & Accept</Button>
				</div>
				<div>
					<Subform { ...this.props}/>
				</div>
				<div>
					<hr className={styles.dividingLine}/>
				</div>
			</div>
		);
	}

	static $resolve (unresolved, scope, addData, Components) {
		const layoutRows = unresolved.extraSettings.layoutDefinition.rows;
		const hasLayoutRows = isNonEmptyArray(layoutRows);
		const isSfiOrgFinder = hasLayoutRows && layoutRows[0].cols[0]?.id?.startsWith("cayuse-org-finder-sfi");

		if (!hasLayoutRows || (hasLayoutRows && !isSfiOrgFinder)) {
			// build org finder config
			const newOrgFinderConfig = { ...orgFinderConfig };
			const orgFinderId = "cayuse-org-finder-sfi-";
			const orgFinderPath = "orgFinderSFI";
			newOrgFinderConfig.id = orgFinderId;
			newOrgFinderConfig.$path = orgFinderPath;
			newOrgFinderConfig.value = `{{${orgFinderPath}}}`;

			// inject the org finder into the SFI component
			unresolved.extraSettings.layoutDefinition.rows = [
				{ cols: [ newOrgFinderConfig ] },
				...unresolved.extraSettings.layoutDefinition.rows
			];
		}

		const resolve = Components.subform.$resolve;

		definition.extraSettings.layoutDefinition = { ...unresolved.extraSettings.layoutDefinition };
		const newDefinition = { ...definition };

		return resolve({ ...unresolved, ...newDefinition }, scope, addData, Components);
	}
}

export default SFIComponent;